import type { RouteObject } from "react-router-dom";
import PublicLayout from "@/components/feature/PublicLayout";
import ProtectedRoute from "@/session/ProtectedRoute";
import ProprietaireLayout from "@/pages/proprietaire/ProprietaireLayout";
import OwnerPermissionGuard from "@/pages/proprietaire/components/OwnerPermissionGuard";
import OwnerDashboard from "@/pages/proprietaire/page";
import ImmeublesPage from "@/pages/proprietaire/immeubles/page";
import ImmeubleDetailPage from "@/pages/proprietaire/immeubles/detail/page";
import BiensPage from "@/pages/proprietaire/biens/page";
import BienDetailPage from "@/pages/proprietaire/biens/detail/page";
import LocatairesPage from "@/pages/proprietaire/locataires/page";
import LocataireDetailPage from "@/pages/proprietaire/locataires/detail/page";
import ContratsPage from "@/pages/proprietaire/contrats/page";
import ContratDetailPage from "@/pages/proprietaire/contrats/detail/page";
import LoyersPage from "@/pages/proprietaire/loyers/page";
import PaiementsPage from "@/pages/proprietaire/paiements/page";
import ImpayesPage from "@/pages/proprietaire/impayes/page";
import DepensesPage from "@/pages/proprietaire/depenses/page";
import OwnerMaintenancePage from "@/pages/proprietaire/maintenance/page";
import InterventionDetailPage from "@/pages/proprietaire/maintenance/detail/page";
import DocumentsPage from "@/pages/proprietaire/documents/page";
import RapportsPage from "@/pages/proprietaire/rapports/page";
import StatistiquesPage from "@/pages/proprietaire/statistiques/page";
import AbonnementPage from "@/pages/proprietaire/abonnement/page";
import ParametresPage from "@/pages/proprietaire/parametres/page";
import Home from "@/pages/home/page";
import FeaturesPage from "@/pages/features/page";
import HowItWorksPage from "@/pages/how-it-works/page";
import SolutionsPage from "@/pages/solutions/page";
import PricingPage from "@/pages/pricing/page";
import FaqPage from "@/pages/faq/page";
import AboutPage from "@/pages/about/page";
import ContactPage from "@/pages/contact/page";
import LoginPage from "@/pages/login/page";
import SignupPage from "@/pages/signup/page";
import ResetPasswordPage from "@/pages/reset-password/page";
import SubscriptionPage from "@/pages/subscription/page";
import FinaliserPaiementPage from "@/pages/finaliser-paiement/page";
import LegalPage from "@/pages/legal/LegalPage";
import ForbiddenPage from "@/pages/error-403/page";
import ServerErrorPage from "@/pages/error-500/page";
import MaintenancePage from "@/pages/maintenance/page";
import NotFound from "@/pages/NotFound";
import AgenceLayout from "@/pages/agence/AgenceLayout";
import AgencePermissionGuard from "@/pages/agence/components/AgencePermissionGuard";
import AgenceDashboard from "@/pages/agence/page";
import AgenceProprietairesPage from "@/pages/agence/proprietaires/page";
import AgenceProprietaireDetailPage from "@/pages/agence/proprietaires/detail/page";
import AgenceImmeublesPage from "@/pages/agence/immeubles/page";
import AgenceImmeubleDetailPage from "@/pages/agence/immeubles/detail/page";
import AgenceBiensPage from "@/pages/agence/biens/page";
import AgenceBienDetailPage from "@/pages/agence/biens/detail/page";
import AgenceLocatairesPage from "@/pages/agence/locataires/page";
import AgenceLocataireDetailPage from "@/pages/agence/locataires/detail/page";
import AgenceContratsPage from "@/pages/agence/contrats/page";
import AgenceContratDetailPage from "@/pages/agence/contrats/detail/page";
import AgenceLoyersPage from "@/pages/agence/loyers/page";
import AgencePaiementsPage from "@/pages/agence/paiements/page";
import AgenceImpayesPage from "@/pages/agence/impayes/page";
import AgenceDepensesPage from "@/pages/agence/depenses/page";
import AgenceMaintenancePage from "@/pages/agence/maintenance/page";
import AgenceInterventionDetailPage from "@/pages/agence/maintenance/detail/page";
import AgenceDocumentsPage from "@/pages/agence/documents/page";
import AgenceRapportsPage from "@/pages/agence/rapports/page";
import AgenceStatistiquesPage from "@/pages/agence/statistiques/page";
import AgenceEmployesPage from "@/pages/agence/employes/page";
import AgenceEmployeDetailPage from "@/pages/agence/employes/detail/page";
import AgenceAbonnementPage from "@/pages/agence/abonnement/page";
import AgenceParametresPage from "@/pages/agence/parametres/page";
import ProprietaireEmployesPage from "@/pages/proprietaire/employes/page";
import ProprietaireEmployeDetailPage from "@/pages/proprietaire/employes/detail/page";
import MesPaiementsPage from "@/pages/mes-paiements/page";
import SuperAdminLayout from "@/pages/super-admin/SuperAdminLayout";
import SuperAdminDashboard from "@/pages/super-admin/page";
import SuperAdminProprietairesPage from "@/pages/super-admin/proprietaires/page";
import SuperAdminProprietaireDetailPage from "@/pages/super-admin/proprietaires/detail/page";
import SuperAdminAgencesPage from "@/pages/super-admin/agences/page";
import SuperAdminAgenceDetailPage from "@/pages/super-admin/agences/detail/page";
import SuperAdminUtilisateursPage from "@/pages/super-admin/utilisateurs/page";
import SuperAdminInscriptionsPage from "@/pages/super-admin/inscriptions/page";
import SuperAdminUtilisateurDetailPage from "@/pages/super-admin/utilisateurs/detail/page";
import SuperAdminAuditPage from "@/pages/super-admin/audit/page";
import SuperAdminStatistiquesPage from "@/pages/super-admin/statistiques/page";
import SuperAdminImmeublesPage from "@/pages/super-admin/immeubles/page";
import SuperAdminImmeubleDetailPage from "@/pages/super-admin/immeubles/detail/page";
import SuperAdminBiensPage from "@/pages/super-admin/biens/page";
import SuperAdminBienDetailPage from "@/pages/super-admin/biens/detail/page";
import SuperAdminLocatairesPage from "@/pages/super-admin/locataires/page";
import SuperAdminLocataireDetailPage from "@/pages/super-admin/locataires/detail/page";
import SuperAdminContratsPage from "@/pages/super-admin/contrats/page";
import SuperAdminContratDetailPage from "@/pages/super-admin/contrats/detail/page";
import SuperAdminFormulesPage from "@/pages/super-admin/formules/page";
import SuperAdminEssaisPage from "@/pages/super-admin/essais/page";
import SuperAdminAbonnementsPage from "@/pages/super-admin/abonnements/page";
import SuperAdminPaiementsPage from "@/pages/super-admin/paiements/page";
import SuperAdminAdministrateursPage from "@/pages/super-admin/administrateurs/page";
import SuperAdminRapportsPage from "@/pages/super-admin/rapports/page";
import SuperAdminParametresPage from "@/pages/super-admin/parametres/page";
import SuperAdminRegionsPage from "@/pages/super-admin/regions/page";
import SuperAdminProvincesPage from "@/pages/super-admin/provinces/page";
import SuperAdminCommunesPage from "@/pages/super-admin/communes/page";
import SuperAdminSecteursPage from "@/pages/super-admin/secteurs/page";

const routes: RouteObject[] = [
  {
    element: <PublicLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "fonctionnalites", element: <FeaturesPage /> },
      { path: "comment-ca-marche", element: <HowItWorksPage /> },
      { path: "solutions", element: <SolutionsPage /> },
      { path: "tarifs", element: <PricingPage /> },
      { path: "faq", element: <FaqPage /> },
      { path: "a-propos", element: <AboutPage /> },
      { path: "contact", element: <ContactPage /> },
      { path: "connexion", element: <LoginPage /> },
      { path: "reinitialiser-mot-de-passe", element: <ResetPasswordPage /> },
      { path: "inscription", element: <SignupPage /> },
      { path: "finaliser-paiement", element: <FinaliserPaiementPage /> },
      { path: "abonnement", element: <SubscriptionPage /> },
      { path: "mentions-legales", element: <LegalPage slug="mentions-legales" /> },
      { path: "confidentialite", element: <LegalPage slug="confidentialite" /> },
      { path: "cgu", element: <LegalPage slug="cgu" /> },
      { path: "cgv", element: <LegalPage slug="cgv" /> },
      { path: "cookies", element: <LegalPage slug="cookies" /> },
      { path: "403", element: <ForbiddenPage /> },
      { path: "500", element: <ServerErrorPage /> },
      { path: "maintenance", element: <MaintenancePage /> },
    ],
  },
  {
    path: "proprietaire",
    element: (
      <ProtectedRoute allowedRoles={["dg_proprietaire", "employe_agence"]}>
        <ProprietaireLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: (
          <OwnerPermissionGuard permission="tableau_bord.voir">
            <OwnerDashboard />
          </OwnerPermissionGuard>
        ),
      },
      {
        path: "immeubles",
        element: (
          <OwnerPermissionGuard permission="immeubles.voir">
            <ImmeublesPage />
          </OwnerPermissionGuard>
        ),
      },
      {
        path: "immeubles/:id",
        element: (
          <OwnerPermissionGuard permission="immeubles.voir">
            <ImmeubleDetailPage />
          </OwnerPermissionGuard>
        ),
      },
      {
        path: "biens",
        element: (
          <OwnerPermissionGuard permission="biens.voir">
            <BiensPage />
          </OwnerPermissionGuard>
        ),
      },
      {
        path: "biens/:id",
        element: (
          <OwnerPermissionGuard permission="biens.voir">
            <BienDetailPage />
          </OwnerPermissionGuard>
        ),
      },
      {
        path: "locataires",
        element: (
          <OwnerPermissionGuard permission="locataires.voir">
            <LocatairesPage />
          </OwnerPermissionGuard>
        ),
      },
      {
        path: "locataires/:id",
        element: (
          <OwnerPermissionGuard permission="locataires.voir">
            <LocataireDetailPage />
          </OwnerPermissionGuard>
        ),
      },
      {
        path: "contrats",
        element: (
          <OwnerPermissionGuard permission="contrats.voir">
            <ContratsPage />
          </OwnerPermissionGuard>
        ),
      },
      {
        path: "contrats/:id",
        element: (
          <OwnerPermissionGuard permission="contrats.voir">
            <ContratDetailPage />
          </OwnerPermissionGuard>
        ),
      },
      {
        path: "loyers",
        element: (
          <OwnerPermissionGuard permission="loyers.voir">
            <LoyersPage />
          </OwnerPermissionGuard>
        ),
      },
      {
        path: "paiements",
        element: (
          <OwnerPermissionGuard permission="paiements.voir">
            <PaiementsPage />
          </OwnerPermissionGuard>
        ),
      },
      {
        path: "impayes",
        element: (
          <OwnerPermissionGuard permission="impayes.voir">
            <ImpayesPage />
          </OwnerPermissionGuard>
        ),
      },
      {
        path: "maintenance",
        element: (
          <OwnerPermissionGuard permission="maintenance.voir">
            <OwnerMaintenancePage />
          </OwnerPermissionGuard>
        ),
      },
      {
        path: "maintenance/:id",
        element: (
          <OwnerPermissionGuard permission="maintenance.voir">
            <InterventionDetailPage />
          </OwnerPermissionGuard>
        ),
      },
      {
        path: "depenses",
        element: (
          <OwnerPermissionGuard permission="depenses.voir">
            <DepensesPage />
          </OwnerPermissionGuard>
        ),
      },
      {
        path: "documents",
        element: (
          <OwnerPermissionGuard permission="documents.voir">
            <DocumentsPage />
          </OwnerPermissionGuard>
        ),
      },
      {
        path: "rapports",
        element: (
          <OwnerPermissionGuard permission="rapports.voir">
            <RapportsPage />
          </OwnerPermissionGuard>
        ),
      },
      {
        path: "statistiques",
        element: (
          <OwnerPermissionGuard permission="statistiques.voir">
            <StatistiquesPage />
          </OwnerPermissionGuard>
        ),
      },
      {
        path: "abonnement",
        element: (
          <OwnerPermissionGuard permission="parametres.voir">
            <AbonnementPage />
          </OwnerPermissionGuard>
        ),
      },
      {
        path: "mes-paiements",
        element: (
          <OwnerPermissionGuard permission="parametres.voir">
            <MesPaiementsPage />
          </OwnerPermissionGuard>
        ),
      },
      {
        path: "employes",
        element: (
          <OwnerPermissionGuard permission="employes.voir">
            <ProprietaireEmployesPage />
          </OwnerPermissionGuard>
        ),
      },
      {
        path: "employes/:id",
        element: (
          <OwnerPermissionGuard permission="employes.voir">
            <ProprietaireEmployeDetailPage />
          </OwnerPermissionGuard>
        ),
      },
      {
        path: "parametres",
        element: (
          <OwnerPermissionGuard permission="parametres.voir">
            <ParametresPage />
          </OwnerPermissionGuard>
        ),
      },
    ],
  },
  {
    path: "agence",
    element: (
      <ProtectedRoute allowedRoles={["dg_agence", "employe_agence"]}>
        <AgenceLayout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <AgenceDashboard /> },
      {
        path: "proprietaires",
        element: (
          <AgencePermissionGuard permission="proprietaires.voir">
            <AgenceProprietairesPage />
          </AgencePermissionGuard>
        ),
      },
      {
        path: "proprietaires/:id",
        element: (
          <AgencePermissionGuard permission="proprietaires.voir">
            <AgenceProprietaireDetailPage />
          </AgencePermissionGuard>
        ),
      },
      {
        path: "immeubles",
        element: (
          <AgencePermissionGuard permission="immeubles.voir">
            <AgenceImmeublesPage />
          </AgencePermissionGuard>
        ),
      },
      {
        path: "immeubles/:id",
        element: (
          <AgencePermissionGuard permission="immeubles.voir">
            <AgenceImmeubleDetailPage />
          </AgencePermissionGuard>
        ),
      },
      {
        path: "biens",
        element: (
          <AgencePermissionGuard permission="biens.voir">
            <AgenceBiensPage />
          </AgencePermissionGuard>
        ),
      },
      {
        path: "biens/:id",
        element: (
          <AgencePermissionGuard permission="biens.voir">
            <AgenceBienDetailPage />
          </AgencePermissionGuard>
        ),
      },
      {
        path: "locataires",
        element: (
          <AgencePermissionGuard permission="locataires.voir">
            <AgenceLocatairesPage />
          </AgencePermissionGuard>
        ),
      },
      {
        path: "locataires/:id",
        element: (
          <AgencePermissionGuard permission="locataires.voir">
            <AgenceLocataireDetailPage />
          </AgencePermissionGuard>
        ),
      },
      {
        path: "contrats",
        element: (
          <AgencePermissionGuard permission="contrats.voir">
            <AgenceContratsPage />
          </AgencePermissionGuard>
        ),
      },
      {
        path: "contrats/:id",
        element: (
          <AgencePermissionGuard permission="contrats.voir">
            <AgenceContratDetailPage />
          </AgencePermissionGuard>
        ),
      },
      {
        path: "loyers",
        element: (
          <AgencePermissionGuard permission="loyers.voir">
            <AgenceLoyersPage />
          </AgencePermissionGuard>
        ),
      },
      {
        path: "paiements",
        element: (
          <AgencePermissionGuard permission="paiements.voir">
            <AgencePaiementsPage />
          </AgencePermissionGuard>
        ),
      },
      {
        path: "impayes",
        element: (
          <AgencePermissionGuard permission="impayes.voir">
            <AgenceImpayesPage />
          </AgencePermissionGuard>
        ),
      },
      {
        path: "depenses",
        element: (
          <AgencePermissionGuard permission="depenses.voir">
            <AgenceDepensesPage />
          </AgencePermissionGuard>
        ),
      },
      {
        path: "maintenance",
        element: (
          <AgencePermissionGuard permission="maintenance.voir">
            <AgenceMaintenancePage />
          </AgencePermissionGuard>
        ),
      },
      {
        path: "maintenance/:id",
        element: (
          <AgencePermissionGuard permission="maintenance.voir">
            <AgenceInterventionDetailPage />
          </AgencePermissionGuard>
        ),
      },
      {
        path: "documents",
        element: (
          <AgencePermissionGuard permission="documents.voir">
            <AgenceDocumentsPage />
          </AgencePermissionGuard>
        ),
      },
      {
        path: "rapports",
        element: (
          <AgencePermissionGuard permission="rapports.voir">
            <AgenceRapportsPage />
          </AgencePermissionGuard>
        ),
      },
      {
        path: "statistiques",
        element: (
          <AgencePermissionGuard permission="statistiques.voir">
            <AgenceStatistiquesPage />
          </AgencePermissionGuard>
        ),
      },
      {
        path: "employes",
        element: (
          <AgencePermissionGuard permission="employes.voir">
            <AgenceEmployesPage />
          </AgencePermissionGuard>
        ),
      },
      {
        path: "employes/:id",
        element: (
          <AgencePermissionGuard permission="employes.voir">
            <AgenceEmployeDetailPage />
          </AgencePermissionGuard>
        ),
      },
      {
        path: "abonnement",
        element: (
          <AgencePermissionGuard permission="parametres.voir">
            <AgenceAbonnementPage />
          </AgencePermissionGuard>
        ),
      },
      {
        path: "mes-paiements",
        element: (
          <AgencePermissionGuard permission="parametres.voir">
            <MesPaiementsPage />
          </AgencePermissionGuard>
        ),
      },
      {
        path: "parametres",
        element: (
          <AgencePermissionGuard permission="parametres.voir">
            <AgenceParametresPage />
          </AgencePermissionGuard>
        ),
      },
    ],
  },
  {
    path: "super-admin",
    element: (
      <ProtectedRoute allowedRoles={["super_admin"]}>
        <SuperAdminLayout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <SuperAdminDashboard /> },
      { path: "proprietaires", element: <SuperAdminProprietairesPage /> },
      { path: "proprietaires/:id", element: <SuperAdminProprietaireDetailPage /> },
      { path: "agences", element: <SuperAdminAgencesPage /> },
      { path: "agences/:id", element: <SuperAdminAgenceDetailPage /> },
      { path: "inscriptions", element: <SuperAdminInscriptionsPage /> },
      { path: "utilisateurs", element: <SuperAdminUtilisateursPage /> },
      { path: "utilisateurs/:id", element: <SuperAdminUtilisateurDetailPage /> },
      { path: "immeubles", element: <SuperAdminImmeublesPage /> },
      { path: "immeubles/:id", element: <SuperAdminImmeubleDetailPage /> },
      { path: "biens", element: <SuperAdminBiensPage /> },
      { path: "biens/:id", element: <SuperAdminBienDetailPage /> },
      { path: "locataires", element: <SuperAdminLocatairesPage /> },
      { path: "locataires/:id", element: <SuperAdminLocataireDetailPage /> },
      { path: "contrats", element: <SuperAdminContratsPage /> },
      { path: "contrats/:id", element: <SuperAdminContratDetailPage /> },
      { path: "formules", element: <SuperAdminFormulesPage /> },
      { path: "essais", element: <SuperAdminEssaisPage /> },
      { path: "abonnements", element: <SuperAdminAbonnementsPage /> },
      { path: "paiements", element: <SuperAdminPaiementsPage /> },
      { path: "administrateurs", element: <SuperAdminAdministrateursPage /> },
      { path: "regions", element: <SuperAdminRegionsPage /> },
      { path: "provinces", element: <SuperAdminProvincesPage /> },
      { path: "communes", element: <SuperAdminCommunesPage /> },
      { path: "secteurs", element: <SuperAdminSecteursPage /> },
      { path: "rapports", element: <SuperAdminRapportsPage /> },
      { path: "parametres", element: <SuperAdminParametresPage /> },
      { path: "statistiques", element: <SuperAdminStatistiquesPage /> },
      { path: "audit", element: <SuperAdminAuditPage /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;